import React, { useEffect, useMemo } from 'react'
import { useDelayTimer, useEventHandler, useInstData } from 'tyan/public/hooks'
import { getListFromValues, getListValuesFromList, getMergedValues } from '../../../utility'

export default props => {
	const { setState, me, me: {
		state: {
			fieldset, components, bodyProps, refreshing = true
		}
	} } = useInstData(props, useMemo(() => ({
		refreshCount: 0,
		state: {
			fieldset: [
				{ _label: '装载中，请稍等...' }
			],
			components: []
		}
	})))

	const { onClose, onConfirm, id, flowName, flowAct, showBody: Body } = props

	const handleRefresh = useEventHandler(() => {
		setState({ refreshing: true })
		const stamp = me.refreshStamp = Date.now()
		const valuesTemp = me.refreshCount ? getMergedValues(me, '') : {}
		const values = {}
		components.forEach(({ name, isList }) => {
			if (isList) {
				const { list } = getListFromValues(name, valuesTemp, {})
				values[name] = list
			} else
				values[name] = valuesTemp[name]
		})

		Tyan.doPostEvent('GetFlowActData', {
			// showFetchSpinner: false,
			data: { flow: flowName, id, status: flowAct.status, act: flowAct.act, input: values },
			onEnd: ({ errorMessage, components, bodyProps }) => {
				if (me.refreshStamp != stamp || me.unmounted) return
				if (errorMessage) {
					// Ext.toast(`读取流程配置数据失败: ${errorMessage}`)
					Tyan.pubForm.showError(`读取流程配置数据失败: ${errorMessage}`)
					console.error('读取流程配置数据失败:', errorMessage)
					onClose()
					return
				}
				let initValues = {}
				const fieldset = components.map(({ /* name,  */type, label, autorefresh, isList, value, ...field }) => {
					field[type] = label || field.name
					autorefresh && (field.onChange = tryRefresh)
					isList
						? value && (initValues = { ...initValues, ...getListValuesFromList(field.name, value) })
						: initValues[field.name] = value
					return field
				})
				me.refreshCount++
				setState({ initValues, changedValues: {}, fieldset, components, refreshing: false, bodyProps })
			}
		})
	})

	const { doDelay } = useDelayTimer(200)
	const tryRefresh = () => {
		doDelay(handleRefresh)
	}

	useEffect(() => {
		handleRefresh()
	}, [])

	const handleCommit = button => {
		// console.log('data:', getMergedValues(me, ''), me)

		if (Tyan.checkForm.promptLimited(me)) return

		const valuesTemp = getMergedValues(me, '')
		const values = {}
		components.forEach(({ name, isList }) => {
			if (isList) {
				const { list } = getListFromValues(name, valuesTemp, {})
				values[name] = list
			} else
				values[name] = valuesTemp[name]
		})
		onConfirm({ button, values })
	}

	const fieldsets = useMemo(() => [{
		title: '', name: '', _fieldset: fieldset, disabled: refreshing
	}], [fieldset, refreshing])

	return <Body data={me} {...(bodyProps || { maxWidth: fieldset.length > 15 ? 1200 : 600 })}
		controls={
			[
				{ _button: '提交', handler: handleCommit, disabled: refreshing },
				{ _button: '取消', handler: onClose },
			]}

		fieldsets={fieldsets}
	/>
}
//             fieldsets={
//                 [
//                     { title: '', name: '', _fieldset: this.fieldset基本信息() },
//                 ]}
//         />
//     }
// }
